import axiosBaseApi from '../common/lib/axiosBaseApi';
import { PokerCategory } from '../common/types/pokerCategory';
import { TableInfo } from '../table/tableTypes';
import { TableQuery, UserLobbyFilter } from './lobbyServicesTypes';

export const getLobbyRest = ({ filter, sort, paginationOptions }: TableQuery) => {
  return axiosBaseApi.get<{ tables: TableInfo[]; total: number }>(`/v1/lobby/`, {
    params: {
      filter: {
        ...filter,
        games: filter?.games?.map((game) => game.games).flat(),
        category: filter?.category === PokerCategory.ALL ? undefined : filter?.category,
      },
      sort,
      paginationOptions,
    },
  });
};

export const saveUserLobbyFilters = (filters: UserLobbyFilter) => {
  return axiosBaseApi.patch<UserLobbyFilter>(`/v1/lobby/user-filters`, filters);
};
